import { mapState, mapActions } from "vuex";
import { showError, showSnackBar } from "@/helpers/globalHelpers";
import { Bar } from 'vue-chartjs';
import { Chart, registerables } from 'chart.js';
import moment from "moment";
import ChartDataLabels from "chartjs-plugin-datalabels";
import JSZip from "jszip";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import pptxgen from "pptxgenjs";
import { saveAs } from "file-saver";
import html2canvas from "html2canvas";
import { formatedTextForZip } from '@/helpers/formatedString';
import  EChartsBarSimple  from "@/components/charts/EChartsBarSimple.vue";
import  EChartsBarDouble  from "@/components/charts/EChartsBarDouble.vue";
Chart.register(...registerables);
Chart.register(ChartDataLabels);

export default {
    name: 'DashboardActionPlanDinamic',
    data() {
      return {
        panel: [],
        readonly: false,
        filteredCostCenters: [],
        isLoadingValidCostCenters: false,
        validCostCenters: [],
        userRole: [],
        tab: 0,
        chartData1: {
          labels: [],
          datasets: [],
        },
        chartData2: {
          labels: [],
          datasets: [],
        },
        chartData3: {
          labels: [],
          datasets: [],
        },
        chartData4: {
          labels: [],
          datasets: [],
        },
        chartOptions1: {
          responsive: true,
          maintainAspectRatio: false,
          layout: {
            padding: {
              top: 20,
            },
          },
          scales: {
            x: {
              ticks: {
                maxRotation: 0,
                minRotation: 0,
                autoSkip: false,
              },
            },
            y: {
              beginAtZero: true,
              max: 100,
              ticks: {
                callback(value) {
                  return value + "%";
                },
                stepSize: 20
              },
            },
          },
          plugins: {
            tooltip: {
              enabled: false,
            },
            legend: {
              display: true,
              position: "bottom",
              labels: {
                generateLabels: (chart) => {
                  const labels = Chart.defaults.plugins.legend.labels.generateLabels(chart);

                  labels.push({
                    text: `N° de acciones ejecutadas ${this.selectedMonthName}`,
                    fillStyle: "#ff5722",
                    strokeStyle: "#ff5722",
                    hidden: false,
                    datasetIndex: -1,
                  });

                  return labels;
                }
              },
              onClick: (evt, legendItem, legend) => {
                const chart = legend.chart;
                const datasetIndex = legendItem.datasetIndex;
    
                if (datasetIndex === -1) {
                  return;
                }
    
                chart.setDatasetVisibility(
                  datasetIndex,
                  !chart.isDatasetVisible(datasetIndex)
                );
                chart.update();
              },
            },
            datalabels: {
              order: 60,
              display: true,
              color: "#000",
              font: {
                weight: "bold",
                size: 20,
              },
              align: "end",
              anchor: "end",
              offset: 5,
              formatter: (value) => {
                return value + "%";
              },
            },
            whiteBackground: {},
            title: {
              display: true,
              text: "",
              font: {
                size: 22,
                weight: "bold",
              },
              color: "#000",
              padding: {
                bottom: 50,
              },
            },
          },
        },
        chartOptions2: {
          responsive: true,
          maintainAspectRatio: false,
          layout: {
            padding: {
              top: 20,
            },
          },
          scales: {
            x: {
              ticks: {
                maxRotation: 0,
                minRotation: 0,
                autoSkip: false,
              },
            },
            y: {
              beginAtZero: true,
              max: 100,
              ticks: {
                callback(value) {
                  return value + "%";
                },
                stepSize: 20
              },
            },
          },
          plugins: {
            tooltip: {
              enabled: false,
            },
            legend: {
              display: true,
              position: "bottom",
              labels: {
                generateLabels: (chart) => {
                  const labels = Chart.defaults.plugins.legend.labels.generateLabels(chart);
       
                  labels.push({
                    text: `N° de acciones programadas ${this.selectedMonthName} vs anual`,
                    fillStyle: "#ffc107",
                    strokeStyle: "#ffc107",
                    hidden: false,
                    datasetIndex: -1,
                  });
                  labels.push({
                    text: `N° de acciones ejecutadas ${this.selectedMonthName} vs anual`,
                    fillStyle: "#ff5722",
                    strokeStyle: "#ff5722",
                    hidden: false,
                    datasetIndex: -1,
                  });
                  labels.push({
                    text: "N° de acciones anual",
                    fillStyle: "#3f51b5",
                    strokeStyle: "#3f51b5",
                    hidden: false,
                    datasetIndex: -1,
                  });
       
                  return labels;
                }
              },
              onClick: (evt, legendItem, legend) => {
                const chart = legend.chart;
                const datasetIndex = legendItem.datasetIndex;
    
                if (datasetIndex === -1) {
                  return;
                }
    
                chart.setDatasetVisibility(
                  datasetIndex,
                  !chart.isDatasetVisible(datasetIndex)
                );
                chart.update();
              },
            },
            datalabels: {
              display: true,
              color: "#000",
              align: "end",
              anchor: "end",
              offset: 5,
              font: {
                weight: "bold",
                size: 20,
              },
              formatter(value) {
                return value + "%";
              },
            },
            whiteBackground: {},
            title: {
              display: true,
              text: "",
              font: {
                size: 22,
                weight: "bold",
              },
              color: "#000",
              padding: {
                bottom: 50,
              },
            },
          },
        },
        chartOptions3: {
          responsive: true,
          maintainAspectRatio: false,
          layout: {
            padding: {
              top: 20,
            },
          },
          scales: {
            x: {
              ticks: {
                maxRotation: 45,
                minRotation: 0,
                autoSkip: false,
              },
            },
            y: {
              beginAtZero: true,
              max: 100,
              ticks: {
                callback(value) {
                  return value + "%";
                },
                stepSize: 20
              },
            },
          },
          plugins: {
            tooltip: {
              enabled: false,
            },
            legend: {
              display: true,
              position: "bottom",
              labels: {
                generateLabels: (chart) => {
                  const labels = Chart.defaults.plugins.legend.labels.generateLabels(chart);

                  labels.push({
                    text: `N° de acciones ejecutadas ${this.selectedMonthName}`,
                    fillStyle: "#ff5722",
                    strokeStyle: "#ff5722",
                    hidden: false,
                    datasetIndex: -1,
                  });

                  return labels;
                }
              },
              onClick: (evt, legendItem, legend) => {
                const chart = legend.chart;
                const datasetIndex = legendItem.datasetIndex;
    
                if (datasetIndex === -1) {
                  return;
                }
    
                chart.setDatasetVisibility(
                  datasetIndex,
                  !chart.isDatasetVisible(datasetIndex)
                );
                chart.update();
              },
            },
            datalabels: {
              order: 60,
              display: true,
              color: "#000",
              font: {
                weight: "bold",
                size: 20,
              },
              align: "end",
              anchor: "end",
              offset: 5,
              formatter: (value) => {
                return value + "%";
              },
            },
            whiteBackground: {},
            title: {
              display: true,
              text: "",
              font: {
                size: 22,
                weight: "bold",
              },
              color: "#000",
              padding: {
                bottom: 50,
              },
            },
          },
        },
        chartOptions4: {
          responsive: true,
          maintainAspectRatio: false,
          layout: {
            padding: {
              top: 20,
            },
          },
          scales: {
            x: {
              ticks: {
                maxRotation: 0,
                minRotation: 0,
                autoSkip: false,
              },
            },
            y: {
              beginAtZero: true,
              max: 100,
              ticks: {
                callback(value) {
                  return value + "%";
                },
                stepSize: 20
              },
            },
          },
          plugins: {
            tooltip: {
              enabled: false,
            },
            legend: {
              display: true,
              position: "bottom",
              labels: {
                generateLabels: (chart) => {
                  const labels = Chart.defaults.plugins.legend.labels.generateLabels(chart);
       
                  labels.push({
                    text: `N° de acciones programadas ${this.selectedMonthName} vs anual`,
                    fillStyle: "#ffc107",
                    strokeStyle: "#ffc107",
                    hidden: false,
                    datasetIndex: -1,
                  });
                  labels.push({
                    text: `N° de acciones ejecutadas ${this.selectedMonthName} vs anual`,
                    fillStyle: "#ff5722",
                    strokeStyle: "#ff5722",
                    hidden: false,
                    datasetIndex: -1,
                  });
                  labels.push({
                    text: "N° de acciones anual",
                    fillStyle: "#3f51b5",
                    strokeStyle: "#3f51b5",
                    hidden: false,
                    datasetIndex: -1,
                  });
       
                  return labels;
                }
              },
              onClick: (evt, legendItem, legend) => {
                const chart = legend.chart;
                const datasetIndex = legendItem.datasetIndex;
    
                if (datasetIndex === -1) {
                  return;
                }
    
                chart.setDatasetVisibility(
                  datasetIndex,
                  !chart.isDatasetVisible(datasetIndex)
                );
                chart.update();
              },
            },
            datalabels: {
              display: true,
              color: "#000",
              align: "end",
              anchor: "end",
              offset: 5,
              font: {
                weight: "bold",
                size: 20,
              },
              formatter(value) {
                return value + "%";
              },
            },
            whiteBackground: {},
            title: {
              display: true,
              text: "",
              font: {
                size: 22,
                weight: "bold",
              },
              color: "#000",
              padding: {
                bottom: 50,
              },
            },
            customAnnotations: {
              totalAmounts: [],
            },
          },
        },
        isLoadingData: false,
        months: [
          { name: "Enero", value: 1 },
          { name: "Febrero", value: 2 },
          { name: "Marzo", value: 3 },
          { name: "Abril", value: 4 },
          { name: "Mayo", value: 5 },
          { name: "Junio", value: 6 },
          { name: "Julio", value: 7 },
          { name: "Agosto", value: 8 },
          { name: "Septiembre", value: 9 },
          { name: "Octubre", value: 10 },
          { name: "Noviembre", value: 11 },
          { name: "Diciembre", value: 12 },
        ],
        managementTypes: [
          { name: "Gerencia", value: "management" },
          { name: "Area", value: "area" },
        ],
        yearValues: [],
        currentMonth: new Date().getMonth() + 1,
        selectedMonth: parseInt(moment().format("M")),
        selectedManagements: null,
        selectedService: null,
        selectedManagementType: null,
        selectedYear: parseInt(moment().format("Y")),
        filteredManagements: [],
        chartTitle1 : 'Gráficos y métricas de cumplimiento por gerencia al mes seleccionado',
        chartTitle2 : 'Gráficos y métricas de cumplimiento planificado vs real',
        chartTitle3 : 'Gráficos y métricas de Servicios',
        chartTitle4 : 'Gráficos y métricas de Servicios asociado la gerencia'
      }
    },

    watch: {
        selectedMonth(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.updateURL();
            }
        },
        selectedManagements(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.updateURL();
            }
        },
    },

    async created() {
        const companyId = localStorage.getItem("company_id");
        this.getAvailableYears({ company_id: companyId }).then((years) => {
          this.yearValues = years;
        });
        await Promise.all([
            this.getPlanType(),
            this.getCostCenterByUserRole()
        ]);
        await this.loadValidCostCenters();
        await this.getCostCenterByUser();
        this.initializeFiltersFromQuery();
        // this.loadData();
        this.addCustomPlugin();
    },

    computed: {
        headers() {
            const monthName = this.findValueMonth(this.selectedMonth)?.name || "";
            return [
              { text: "Servicio", value: "serviceName" },
              {
                text: `N° de acciones programadas Enero - ${monthName}`,
                value: "tasksUntilSelectedMonth",
              },
              {
                text: `N° de acciones ejecutadas Enero - ${monthName}`,
                value: "completedTasksUntilSelectedMonth",
              },
              { text: "% de cumplimiento", value: "advancePercentageService" },
              { text: "Plan de acción anual totales", value: "totalAnnualTasks" },
              {
                text: `% programado Enero - ${monthName}`,
                value: "completionPercentage",
              },
              {
                text: `% ejecutado Enero - ${monthName}`,
                value: "executionPercentage",
              },
              
            ];
          },
          serviceComplianceHeaders() {
            const monthName = this.findValueMonth(this.selectedMonth)?.name || "";
            return [
              { text: "Nombre del Servicio", value: "serviceName" },
              {
                text: `Total Acciones Ejecutadas (Enero - ${monthName})`,
                value: "completedTasks",
              },
              {
                text: `Porcentaje de Cumplimiento (Enero - ${monthName})`,
                value: "completionPercentage",
              },
            ];
          },
          complianceByManagementHeaders() {
            const monthName = this.findValueMonth(this.selectedMonth)?.name || "";
            return [
              { text: "Gerencia", value: "managementName" },
              {
                text: `N° acciones ejecutadas Enero - ${monthName}`,
                value: "totalCompleted",
              },
              {
                text: `% de cumplimiento Enero - ${monthName}`,
                value: "overallCompletionPercentage",
              },
            ];
          },
          plannedVsRealComplianceHeaders() {
            const monthName = this.findValueMonth(this.selectedMonth)?.name || "";
            return [
              { text: "Gerencia", value: "managementName" },
              {
                text: `N° de acciones programadas Enero - ${monthName}`,
                value: "tasksUntilSelectedMonth",
              },
              {
                text: `N° de acciones ejecutadas Enero - ${monthName}`,
                value: "completedTasksUntilSelectedMonth",
              },
              { text: "% de cumplimiento", value: "advancePercentageManagement" },
              { text: "Plan de acción anual totales", value: "totalAnnualTasks" },
              {
                text: `% programado Enero - ${monthName}`,
                value: "plannedCompletionPercentage",
              },       
              {
                text: `% ejecutado Enero - ${monthName}`,
                value: "realCompletionPercentage",
              },
              
            ];
          },
        breadcrumbs() {
            return [
                {
                    text: "Inicio",
                    link: true,
                    exact: true,
                    disabled: false,
                    to: {
                        name: "Dashboard",
                    },
                },
                {
                    text: "Graficos",
                    link: true,
                    exact: true,
                    disabled: false,
                    to: {
                        name: "DashboardActionPlan",
                    },
                },
            ];
        },
        selectedMonthName() {
          let monthName = this.months.find(m => m.value === this.selectedMonth)?.name || "";
          this.updateChartTitles(monthName);
          return monthName;
        },

        // Auxiliar para obtener la gerencia seleccionada (si es solo una)
        managementSelected() {
            if (this.selectedManagements?.length === 1) {
                return this.managementsUserCompany.find(mng => mng.id == this.selectedManagements[0]);
            }
            return null;
        },

        titleChart1() {
            const month = this.selectedMonthName;
            const plan = this.planType?.type_name || "";
            if (this.managementSelected) {
                return `Avance ${plan} - ${this.managementSelected.name} a ${month}`;
            }
            return `Avance Gerencia de Área de Negocio a ${month}`;
        },

        titleChart2() {
            const month = this.selectedMonthName;
            const plan = this.planType?.type_name || "";
            if (this.managementSelected) {
                return `Porcentaje de avance ${plan} - ${this.managementSelected.name} a ${month}`;
            }
            return `Porcentaje de avance - Gerencia de Área de Negocio a ${month}`;
        },

        titleChart3() {
            const month = this.selectedMonthName;
            const plan = this.planType?.type_name || "";
            if (this.managementSelected) {
                return `Avance ${plan} - Servicio seleccionado a ${month}`;
            }
            // Título por defecto si no hay selección individual
            return `CUMPLIMIENTO POR SERVICIO - ${month.toUpperCase()}`;
        },

        titleChart4() {
            const month = this.selectedMonthName;
            const plan = this.planType?.type_name || "";
            if (this.managementSelected) {
                return `Porcentaje de avance ${plan} - Servicio seleccionado a ${month}`;
            }
            // Título por defecto si no hay selección individual
            return `GESTIÓN DE SERVICIOS ASOCIADOS A LA GERENCIA - ${month.toUpperCase()}`;
        },


        ...mapState("auth", ["user"]),
        ...mapState("security", [
            "managementsUser",
            "allCostCenters",
            "allManagementsState",
            "managementsUserCompany",
            "costCentersUserRole"
        ]),
        ...mapState("action_plan", ["reportDashboardData"]),

           profiles() {
      const companies = this.$store.state.auth.user?.companies || [];
      const currentCompanyId = localStorage.getItem("company_id");
      const profiles = [];

      if (Array.isArray(companies)) {
        const company = companies.find(
          (c) => String(c.id) === String(currentCompanyId)
        );

        if (company) {
          company.profiles?.forEach((profile) => {
            profiles.push(profile.role);
          });
        }
      }

      return profiles;
    },

        ...mapState("plan_type", ["planType"]),

        isAuthorized() {
            const planTypeProfiles = this.planType?.profiles?.map(
                (profile) => profile.profile.id
            );

            return this.profiles?.some((profile) =>
                planTypeProfiles?.includes(profile.id)
            );
        },
    },
    methods: {
        ...mapActions('plan_type', ['getPlanTypeByIdV2', 'cleanPlanTypeId']),

        ...mapActions("action_plan", [
            "getReportDashboardData",
            "getAvailableYears"
        ]),
        ...mapActions("security", [
            "getCostCenterUser",
            "allManagements",
            "getManagementsUserCompany",
            "getCostCenterUserRole"
        ]),

        async getPlanType() {
            this.isLoadingPlanType = true;
            const { planTypeId } = this.$route.params;
            const { error } = await this.getPlanTypeByIdV2({ id: planTypeId, populate: true, relations:'profiles' })
            if (error) showError(error);

            if (!this.isAuthorized) {
                this.$router.push({ name: "NotAuthorized" });
            }

            this.isLoadingPlanType = false;
        },

            async getCostCenterByUserRole() {
      this.loadingCostCenter = true;
      const { error } = await this.getCostCenterUserRole({
        user_id: this.user.id,
      });
      if (error) showError(error);
      this.loadingCostCenter = false;
    },

    loadValidCostCenters() {
            this.isLoadingValidCostCenters = true;
            const planTypeProfiles = this.planType?.profiles?.map(p => p.profile.id) || [];
            const userProfileIds = this.profiles.map(p => p.id);
            const matchingRoleIds = planTypeProfiles.filter(roleId =>
                userProfileIds.includes(roleId)
            );

            const validRoles = this.costCentersUserRole.filter(r =>
                matchingRoleIds.includes(r.role_id)
            );
            this.userRole = validRoles.map(r => r.role_id);
            this.validCostCenters = Array.from(
              new Map(
                validRoles
                  .flatMap(r => r.costCenters)
                  .map(cc => [cc.id, cc])
              ).values()
            );
            this.isLoadingValidCostCenters = false;
        },

        initializeFiltersFromQuery() {
            const month = this.$route.query.selectedMonth;

            if (month !== undefined) {
                this.selectedMonth = parseInt(month);
            }
        },

        async loadData() {
            this.isLoadingData = true;
            await this.getReportData();
            this.isLoadingData = false;
        },

        async getCostCenterByUser() {
            const { error } = await this.getManagementsUserCompany({ user_id: this.user.id, user_role_id: this.userRole });
            if (error) {
                showError(error);
            } else {

                this.selectedManagementType = 'area';

                const management_id = this.$route.query.selectedManagement;

                if (management_id !== undefined) {
                    const foundManagementFilter = this.managementsUserCompany.find(management => management.id === parseInt(management_id));

                    if (foundManagementFilter) {
                        this.selectedManagementType = foundManagementFilter.management_type;
                    }
                }

                this.updateManagementType();
         
            }
        },

        filterCostCenters() {
            if (this.selectedManagements) {
                const management = this.managementsUser.find(m => m.id === this.selectedManagements);
                this.filteredCostCenters = management ? management.costCenters : [];
            } else {
                this.filteredCostCenters = this.allCostCenters;
            }
        },

        async getReportData() {
          if (!this.selectedManagements) return;

          this.loadingActionPlan = true;

          try {
            const data = await this.getReportDashboardData({
              month: this.selectedMonth,
              management_ids: JSON.stringify(this.selectedManagements),
              service_id: this.selectedService,
              management_type: this.selectedManagementType,
              plan_type_id: this.$route.params.planTypeId,
            });

            if (!data?.ok) {
              showError(data.error || "Error al obtener el reporte");
              return;
            }
            this.processReportData(data.response);
          } catch (error) {
            showError(
              error?.message || "Ocurrió un error inesperado al obtener el reporte"
            );
          } finally {
            this.loadingActionPlan = false;
          }
        },

        roundPercentage(value) {
            return value !== null && value !== undefined ? Math.round(value) : "-";
          },
      
          getCompletionColor(percentage) {
            if (percentage === 100) return "success";
            if (percentage >= 51) return "yellow accent-4";
            return "error";
          },

          processReportData(data) {
            /**
             * First chart
             */
            const generalManagements = data.DashboardComplianceByManagementForSelectedMonth;

            const generalLabels = generalManagements.map((item) => item.managementName);
            const overallCompletionPercentage = generalManagements.map(
              (item) => Math.round(item.overallCompletionPercentage)
            );
            const totalCompleted = generalManagements.map(
              (item) => Math.round(item.totalCompleted)
            );

            this.chartData1 = {
              labels: generalLabels,
              datasets: [{
                label: "Cumplimiento",
                data: overallCompletionPercentage,
                rawAmounts: totalCompleted,        
                color: "#63d1d3"                   
              }]
            };
      
            /**
             * second chart
             */
            const plannedRealComplieance = data.DashboardPlannedVsRealCompliance;

            const managementNames = plannedRealComplieance.map((item) => item.managementName);
            const chartTwoTotalAnnualTasks = plannedRealComplieance.map(item => item.totalAnnualTasks);
            const chartTwotasksUntilSelectedMonth = plannedRealComplieance.map(
              (item) => Math.round(item.tasksUntilSelectedMonth)
            );
            const chartTwoplannedCompletionPercentage = plannedRealComplieance.map(
              (item) => Math.round(item.plannedCompletionPercentage)
            );
            const chartTwocompletedTasksUntilSelectedMonth = plannedRealComplieance.map(
              (item) => Math.round(item.completedTasksUntilSelectedMonth)
            );
            const chartTworealCompletionPercentage = plannedRealComplieance.map(
              (item) => Math.round(item.realCompletionPercentage)
            );

            this.chartData2 = {
              labels: managementNames,
              annualTotals: chartTwoTotalAnnualTasks, 
              datasets: [
                {
                  label: "% programado", // El componente sobreescribirá esto con el nombre largo
                  data: chartTwoplannedCompletionPercentage,
                  rawAmounts: chartTwotasksUntilSelectedMonth,
                  color: "#cccccc" 
                },
                {
                  label: "% ejecutado",
                  data: chartTworealCompletionPercentage,
                  rawAmounts: chartTwocompletedTasksUntilSelectedMonth,
                  color: "#63d1d3" 
                }
              ]
            };
      
            this.chartOptions2 = {
              ...this.chartOptions2,
              scales: {
                ...this.chartOptions2.scales,
                y: {
                  ...this.chartOptions2.scales?.y,
                  max: 100,
                  beginAtZero: true,
                  ticks: {
                    callback: (value) => `${value}%`,
                    stepSize: 20                    
                  },
                },
              },
              plugins: {
                ...this.chartOptions2.plugins,
                customAnnotations: {
                  ...this.chartOptions2.plugins.customAnnotations,
                  totalAmounts: chartTwoTotalAnnualTasks,
                },
              },
            };
      
            /**
             *  third chart
             */
            const serviceCompliance = data.DashboardServiceCompliance;
            const serviceNames = serviceCompliance.map((item) => item.serviceName);
            const chartThreeCompletedTasks = serviceCompliance.map((item) => Math.round(item.completedTasks));
            const chartThreeCompletionPercentage = serviceCompliance.map((item) => Math.round(item.completionPercentage));

            this.chartData3 = {
              labels: serviceNames,
              datasets: [
                {
                  label: `% cumplimiento Enero - ${this.months[this.selectedMonth - 1]?.name}`,
                  data: chartThreeCompletionPercentage,
                  rawAmounts: chartThreeCompletedTasks,
                },
              ],
            };
      
            /**
             * fourth chart
             */
            const associateServicesManagement = data.AssociatedServicesToManagement;
            const associateServicesNames = associateServicesManagement.map((item) => item.serviceName);

            // Datos para la caja negra inferior
            const chartFourthTotalAnnualTasks = associateServicesManagement.map((item) => Math.round(item.totalAnnualTasks));

            // Datos para el cubo gris (% programado)
            const chartFourthtasksUntilSelectedMonth = associateServicesManagement.map((item) => Math.round(item.tasksUntilSelectedMonth));
            const chartFourthplannedCompletionPercentage = associateServicesManagement.map((item) => Math.round(item.completionPercentage));

            // Datos para el cubo cian (% ejecutado)
            const chartFourthcompletedTasksUntilSelectedMonth = associateServicesManagement.map((item) => Math.round(item.completedTasksUntilSelectedMonth));
            const chartFourthrealCompletionPercentage = associateServicesManagement.map((item) => Math.round(item.executionPercentage));

            this.chartData4 = {
              labels: associateServicesNames,
              annualTotals: chartFourthTotalAnnualTasks, // Nueva propiedad para la caja negra
              datasets: [
                {
                  label: `% programado Enero - ${this.months[this.selectedMonth - 1]?.name} vs anual`,
                  data: chartFourthplannedCompletionPercentage,
                  rawAmounts: chartFourthtasksUntilSelectedMonth,
                },
                {
                  label: `% ejecutado ${this.months[this.currentMonth - 1]?.name} - ${this.months[this.selectedMonth - 1]?.name} vs anual`,
                  data: chartFourthrealCompletionPercentage,
                  rawAmounts: chartFourthcompletedTasksUntilSelectedMonth,
                },
              ],
            };  
      
            this.chartOptions4 = {
              ...this.chartOptions4,
              scales: {
                ...this.chartOptions4.scales,
                y: {
                  ...this.chartOptions4.scales?.y,
                  max: 100,
                  beginAtZero: true,
                  ticks: {
                    callback: (value) => `${value}%`,
                    stepSize: 20
                  },
                },
              },
              plugins: {
                ...this.chartOptions4.plugins,
                customAnnotations: {
                  ...this.chartOptions4.plugins.customAnnotations,
                  totalAmounts: chartFourthTotalAnnualTasks,
                },
              },
            };
          },

          addCustomPlugin() {
            const customPlugin = {
              id: "customAnnotations",
              order: 50,
              afterDatasetsDraw(chart) {
                const ctx = chart.ctx;
                const chartArea = chart.chartArea;
                const datasets = chart.data.datasets;
                const totalAmounts =
                  chart.options.plugins.customAnnotations.totalAmounts;
      
                if (!datasets || !Array.isArray(datasets) || datasets.length === 0)
                  return;
      
                datasets.forEach((dataset, datasetIndex) => {
                  if (!dataset.rawAmounts || !Array.isArray(dataset.rawAmounts))
                    return;
      
                  dataset.rawAmounts.forEach((amount, index) => {
                    const meta = chart.getDatasetMeta(datasetIndex);
                    const bar = meta.data[index];
                    if (!bar) return;
      
                    const porcentaje = dataset.data[index];
      
                    if (!porcentaje || porcentaje === 0) {
                      return;
                    }
      
                    const isMultiDataset = datasets.length > 1;
      
                    let circleColor = isMultiDataset 
                      ? (datasetIndex === 0 ? "#FFC107" : "#FF5722")
                      : "#FF5722";
      
                    const circleRadius = 20;
                    const x = bar.x;
                    const circleY = chartArea.bottom - circleRadius + 7;
      
                    ctx.save();
                    ctx.beginPath();
                    ctx.arc(x, circleY, circleRadius, 0, 2 * Math.PI);
                    ctx.fillStyle = circleColor;
                    ctx.fill();
      
                    ctx.fillStyle = "#fff";
                    ctx.font = "bold 18px Arial";
                    ctx.textAlign = "center";
                    ctx.textBaseline = "middle";
                    ctx.fillText(amount, x, circleY);
                    ctx.restore();
                  });
      
                  if (!totalAmounts || !Array.isArray(totalAmounts)) return;
      
                  totalAmounts.forEach((total, index) => {
                    const meta = chart.getDatasetMeta(0);
                    const bar = meta.data[index];
                    const x = bar.x - bar.width * 0.45;
                    const y = chartArea.bottom +40;
                    const width = bar.width * 2;
                    const height = 30;
      
                    ctx.save();
                    ctx.beginPath();
                    ctx.rect(x, y - 40, width, height);
                    ctx.fillStyle = "#3f51b5";
                    ctx.fill();
                    ctx.fillStyle = "#ffffff";
                    ctx.font = "bold 18px Arial";
                    ctx.textAlign = "center";
                    ctx.fillText(total, x + bar.width, y - 20);
                    ctx.restore();
                  });
                });
              },
            };
            Chart.register(customPlugin);
      
            const whiteBackgroundPlugin = {
              id: "whiteBackground",
              beforeDraw(chart) {
                const { ctx, chartArea } = chart;
                ctx.save();
                ctx.fillStyle = "#FFFFFF";
                ctx.fillRect(chartArea.left, chartArea.top, chartArea.right - chartArea.left, chartArea.bottom - chartArea.top);
                ctx.restore();
              },
            };
            Chart.register(whiteBackgroundPlugin);
          },

        redirectToDetail() {
            //TODO verificar con managmeentsUser si el management seleccionado existe en su perfil
            this.$router.push({
                name: 'ReportActionPlansDinamic',
                params: {
                    planTypeId: this.$route.params.planTypeId
                },
                query: {
                    month: this.selectedMonth,
                    management_ids: this.selectedManagements
                }
            });
        },

        updateCharts() {
            this.loadData();
        },

        updateManagementType() {
    if (this.selectedManagementType && this.managementsUserCompany.length) {
        let filterManagements = this.managementsUserCompany.filter(
            ccu => ccu.management_type === this.selectedManagementType
        );

        this.filteredManagements = filterManagements;

        if (!filterManagements.length) {
            filterManagements = this.managementsUserCompany;
        }

        let mngId = this.$route.query.selectedManagement;
        this.selectedManagements = mngId
            ? [mngId]
            : [filterManagements[0].id];
    } else {
        this.selectedManagements = [];
    }

    this.updateCharts();
        },

        updateURL() {
            if (this.$route.name === 'DashboardActionPlanDinamic') {
                this.$router.push({
                    query: {
                        selectedMonth: this.selectedMonth,
                        selectedManagements: this.selectedManagements || undefined
                    }
                }).catch(err => {
                    if (err.name !== "NavigationDuplicated") {
                      showSnackBar(`Error interno, contactarse con el administrador`, "error");
                    }
                });
            }
        },

        findValueMonth(monthSelected) {
            if (monthSelected) {
                const data = this.months.find(month => month.value === monthSelected)
                return data;
            } else {
                return '-'
            }
        },

        async downloadChart(refName) {
          const chartComponent = this.$refs[refName];
          if (!chartComponent) {
            //showSnackBar(`No existe la referencia ${refName}`, "error");
            return null;
          }
        
          const canvas = chartComponent.$el;
          if (!canvas) {
            showSnackBar(`No se encontró el canvas dentro del componente.`, "error");
            return null;
          }
        
          return new Promise((resolve) => {
            const originalWidth = canvas.width;
            const originalHeight = canvas.height;
            const scaleFactor = window.devicePixelRatio || 2;
        
            const tempCanvas = document.createElement("canvas");
            tempCanvas.width = originalWidth * scaleFactor;
            tempCanvas.height = originalHeight * scaleFactor;
            const ctx = tempCanvas.getContext("2d");
        
            ctx.fillStyle = "#FFFFFF";
            ctx.fillRect(0, 0, tempCanvas.width, tempCanvas.height);
        
            ctx.scale(scaleFactor, scaleFactor);
            ctx.drawImage(canvas, 0, 0, originalWidth, originalHeight);
        
            tempCanvas.toBlob((blob) => {
              resolve({ name: `${refName}.png`, blob });
            }, "image/png");
          });
        },

        async downloadAllChartsAsZip() {
          await this.openPanels();

          const chartRefs = ["chart1", "chart2", "chart3", "chart4"];
          const chartTitles = [
            this.chartTitle1,
            this.chartTitle2,
            this.chartTitle3,
            this.chartTitle4,
          ];
        
          const zip = new JSZip();
        
          const images = await Promise.all(
            chartRefs.map(async (ref) => {
              return await this.downloadChart(ref);
            })
          );
        
          images.forEach((file, index) => {
            if (file) {
              const formattedTitle = formatedTextForZip(chartTitles[index]);
              zip.file(`Graficos/${formattedTitle}.png`, file.blob);
            }
          });
        
          const planTypeFormated = formatedTextForZip(this.planType?.type_name);
          const zipFileName = `Graficos_${planTypeFormated}_${moment().format(
            "YYYY_MM_DD_HH_mm"
          )}.zip`;
        
          zip.generateAsync({ type: "blob" }).then((content) => {
            saveAs(content, zipFileName);
          });
        },

        async downloadAllChartsAsPDF() {
          await this.openPanels();

          await new Promise(resolve => setTimeout(resolve, 800));

          const chartRefs = ["chart1", "chart2", "chart3", "chart4"];
          const pdf = new jsPDF("l", "mm", "a4");
          
          const pageWidth = pdf.internal.pageSize.getWidth();  
          const pageHeight = pdf.internal.pageSize.getHeight(); 
          
          const margin = 10;
          const targetWidth = pageWidth - (margin * 2); 

          let hasDrawnPage = false;

          for (let i = 0; i < chartRefs.length; i++) {
            const chartComponent = this.$refs[chartRefs[i]];

            const imgData = chartComponent ? chartComponent.getChartImage() : null;

            if (!imgData) continue;

            if (hasDrawnPage) pdf.addPage();

            const imgProps = pdf.getImageProperties(imgData);
            
            const finalH = (imgProps.height * targetWidth) / imgProps.width;

            const yPos = (pageHeight - finalH) / 2;

            pdf.addImage(
              imgData, 
              "PNG", 
              margin, 
              yPos, 
              targetWidth, 
              finalH, 
              undefined, 
              "FAST"
            );

            hasDrawnPage = true;
          }

          const planTypeFormated = formatedTextForZip(this.planType?.type_name);
          if (hasDrawnPage) {
            pdf.save(
              `Graficos_${planTypeFormated}_${moment().format(
            "YYYY_MM_DD_HH_mm"
          )}.pdf`
            );
          }
        },

        async downloadAllChartsAsPPTX() {
          await this.openPanels();
          await new Promise(resolve => setTimeout(resolve, 1000));

          const pres = new pptxgen();
          pres.layout = 'LAYOUT_16x9';

          const chartRefs = ["chart1", "chart2", "chart3", "chart4"];

          for (let i = 0; i < chartRefs.length; i++) {
            const chartComponent = this.$refs[chartRefs[i]];
            const imgData = chartComponent ? chartComponent.getChartImage() : null;

            if (!imgData) continue;

            const slide = pres.addSlide();

            slide.addImage({
              data: imgData,
              x: 0.5,      
              y: 0.5,      
              w: '90%',   
              h: '85%',    
              sizing: { 
                type: 'contain', 
                align: 'center', 
                valign: 'middle'
              } 
            });
          }

          const planTypeFormated = formatedTextForZip(this.planType?.type_name);
          pres.writeFile({ 
            fileName: `Graficos_${planTypeFormated}_${moment().format(
            "YYYY_MM_DD_HH_mm"
          )}.pptx` 
          });
        },

      blobToBase64(blob) {
        return new Promise(resolve => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result);
          reader.readAsDataURL(blob);
        });
      },

      updateChartTitles(monthName) {
        if (this.selectedManagements != null) {
          // Grupal
          this.chartOptions1.plugins.title.text = `Avance Gerencia de Área de Negocio a ${monthName}`;
          this.chartOptions2.plugins.title.text = `Porcentaje de avance - Gerencia de Área de Negocio a ${monthName}`;
  
          // Individual
          if (this.selectedManagements.length == 1) {
            let managementSelected = this.managementsUserCompany.find(mng => mng.id == this.selectedManagements[0]);
            this.chartOptions1.plugins.title.text = `Avance ${this.planType?.type_name} - ${managementSelected.name} a ${monthName}`;
            this.chartOptions2.plugins.title.text = `Porcentaje de avance ${this.planType?.type_name} - ${managementSelected.name} a ${monthName}`;
            this.chartOptions3.plugins.title.text = `Avance ${this.planType?.type_name} - Servicio seleccionado a ${monthName}`;
            this.chartOptions4.plugins.title.text = `Porcentaje de avance ${this.planType?.type_name} - Servicio seleccionado a ${monthName}`;
          }
        }
      },

      async downloadAllTablesZip(){
        // Abrir Collapsibles
        await this.openPanels();
  
        const tableRefs = ["dataTable1", "dataTable2", "dataTable3", "dataTable4"];
        const chartTitles = [this.chartTitle1, this.chartTitle2, this.chartTitle3, this.chartTitle4];
      
        // Capturar img de las tablas
        const images = await Promise.all(
          tableRefs.map(async (ref) => {
            return await this.downloadTables(ref);
          })
        );
      
        const zip = new JSZip();
        images.forEach((file, index) => {
          if (file) {
            const formattedTitle = formatedTextForZip(chartTitles[index]);
            zip.file(`Tablas de Métricas/${formattedTitle}.png`, file.blob);
          }
        });
        
        const planTypeFormated = formatedTextForZip(this.planType?.type_name);
        const zipFileName = `Metricas_${planTypeFormated}_${moment().format(
          "YYYY_MM_DD_HH_mm"
        )}.zip`;
      
        zip.generateAsync({ type: "blob" }).then((content) => {
          saveAs(content, zipFileName);
        });
      },

      hexToRgb(hex) {
      if (!hex) return [0, 0, 0];
      const cleanHex = hex.replace('#', '');
      const bigint = parseInt(cleanHex, 16);
      return [(bigint >> 16) & 255, (bigint >> 8) & 255, bigint & 255];
    },

    async downloadAllTablesAsPDF() {
      await this.openPanels();
      await new Promise(resolve => setTimeout(resolve, 800));

      const pdf = new jsPDF("l", "mm", "a4");
      const pageWidth = pdf.internal.pageSize.getWidth();

      const tablesConfig = [
        {
          ref: 'dataTable1', 
          title: this.chartOptions1?.plugins.title.text || "Cumplimiento por Gerencia",
          headers: this.complianceByManagementHeaders,
          data: this.reportDashboardData?.DashboardComplianceByManagementForSelectedMonth || [],
          chipColumns: ['totalCompleted'],
          getColorValue: (item) => item.overallCompletionPercentage
        },
        {
          ref: 'dataTable2',
          title: this.chartOptions2?.plugins.title.text || "Cumplimiento Planificado vs Real",
          headers: this.plannedVsRealComplianceHeaders,
          data: this.reportDashboardData?.DashboardPlannedVsRealCompliance || [],
          chipColumns: ['completedTasksUntilSelectedMonth', 'tasksUntilSelectedMonth'],
          getColorValue: (item) => item.advancePercentageManagement
        },
        {
          ref: 'dataTable3',
          title: this.chartOptions3?.plugins.title.text || "Cumplimiento por Servicio",
          headers: this.serviceComplianceHeaders,
          data: this.reportDashboardData?.DashboardServiceCompliance || [],
          chipColumns: ['completedTasks'],
          getColorValue: (item) => item.completionPercentage
        },
        {
          ref: 'dataTable4',
          title: this.chartOptions4?.plugins.title.text || "Servicios Asociados",
          headers: this.headers,
          data: this.reportDashboardData?.AssociatedServicesToManagement || [],
          chipColumns: ['completedTasksUntilSelectedMonth', 'tasksUntilSelectedMonth'],
          getColorValue: (item) => item.advancePercentageService
        }
      ];

      let currentY = 15;
      let hasPrintedTable = false;

      for (let i = 0; i < tablesConfig.length; i++) {
        const tConfig = tablesConfig[i];

        if (!tConfig.data || tConfig.data.length === 0) continue;

        const component = this.$refs[tConfig.ref];

        if (!component) continue;

        const domEl = component.$el || component;
        if (domEl.offsetParent === null) continue;

        if (hasPrintedTable) {
          pdf.addPage();
          currentY = 15;
        }

        pdf.setFont("helvetica", "bold");
        pdf.setFontSize(14);
        pdf.setTextColor(0, 0, 0);
        pdf.text(tConfig.title, pageWidth / 2, currentY, { align: 'center' });
        currentY += 8;

        autoTable(pdf, {
          startY: currentY,
          columns: tConfig.headers.map(h => ({ header: h.text, dataKey: h.value })),
          
          body: tConfig.data.map(item => {
            const row = { ...item };
            Object.keys(row).forEach(key => {
              if (key.toLowerCase().includes('percentage') && typeof row[key] === 'number') {
                row[key] = `${this.roundPercentage(row[key])}%`;
              }
            });
            ['completedTasksUntilSelectedMonth', 'tasksUntilSelectedMonth', 'totalCompleted', 'completedTasks'].forEach(k => {
              if (row[k] !== undefined && row[k] !== null) row[k] = row[k].toString();
            });
            row._rawItem = item; 
            return row;
          }),

          theme: 'plain',
          headStyles: {
            fillColor: [255, 255, 255],
            textColor: [100, 100, 100],
            fontStyle: 'bold',
            fontSize: 9,
            halign: 'center',
            valign: 'middle',
            lineColor: [220, 220, 220],
            lineWidth: { bottom: 0.5 }
          },
          styles: {
            font: 'helvetica',
            fontSize: 9,
            textColor: [60, 60, 60],
            valign: 'middle',
            halign: 'center',
            lineColor: [240, 240, 240],
            lineWidth: { bottom: 0.1 },
            minCellHeight: 12
          },
          columnStyles: {
            0: { halign: 'left' }
          },

          willDrawCell: (data) => {
            if (data.section === 'body') {
              const colKey = data.column.dataKey;
              if (tConfig.chipColumns.includes(colKey)) {
                const rawItem = data.row.raw._rawItem;
                const percentageForColor = tConfig.getColorValue(rawItem);
                const colorClass = this.getCompletionColor(percentageForColor);
                
                let hexColor = '#999999';
                switch (colorClass) {
                  case 'success': hexColor = '#4CAF50'; break;
                  case 'yellow accent-4': hexColor = '#FFD600'; break;
                  case 'error': hexColor = '#FF5252'; break;
                }

                const rgb = this.hexToRgb(hexColor);
                const chipW = 18; const chipH = 7;
                const x = data.cell.x + (data.cell.width - chipW) / 2;
                const y = data.cell.y + (data.cell.height - chipH) / 2;

                pdf.setFillColor(rgb[0], rgb[1], rgb[2]);
                pdf.roundedRect(x, y, chipW, chipH, 3, 3, 'F');
                pdf.setTextColor(255, 255, 255);
                pdf.setFont("helvetica", "bold");
              } else {
                pdf.setTextColor(60, 60, 60);
                pdf.setFont("helvetica", "normal");
              }
            }
          },

          didDrawPage: (d) => { currentY = d.cursor.y; }
        });

        hasPrintedTable = true;
        currentY = pdf.lastAutoTable.finalY + 15;
      }
      const planTypeFormated = formatedTextForZip(this.planType?.type_name);
      pdf.save(`Metricas_${planTypeFormated}_${moment().format(
          "YYYY_MM_DD_HH_mm"
        )}.pdf`);
    },

    async downloadAllTablesAsPPTX() {
      await this.openPanels();
      await new Promise(resolve => setTimeout(resolve, 800));

      const pres = new pptxgen();
      pres.layout = "LAYOUT_4x3";

      const tableRefs = ["dataTable1", "dataTable2", "dataTable3", "dataTable4"];

      for (let i = 0; i < tableRefs.length; i++) {
        const component = this.$refs[tableRefs[i]];
        const originalEl = component?.$el || component;

        if (!originalEl) continue;

        const clonedEl = originalEl.cloneNode(true);
        const container = document.createElement("div");
        
        container.style.position = "absolute";
        container.style.left = "-9999px";
        container.style.top = "0";
        container.style.width = "950px";
        container.style.backgroundColor = "#ffffff";
        container.classList.add("v-application", "theme--light");
        
        container.appendChild(clonedEl);
        document.body.appendChild(container);

        const tableTag = clonedEl.querySelector("table");
        if (tableTag) {
            tableTag.style.setProperty("width", "100%", "important");
        }

        clonedEl.style.setProperty("width", "100%", "important");

        const originalChips = originalEl.querySelectorAll(".v-chip");
        const clonedChips = clonedEl.querySelectorAll(".v-chip");
        originalChips.forEach((origChip, index) => {
          if (clonedChips[index]) {
            const computed = window.getComputedStyle(origChip);
            clonedChips[index].style.backgroundColor = computed.backgroundColor;
            clonedChips[index].style.color = computed.color;
            clonedChips[index].style.opacity = "1";
          }
        });

        const toolbar = clonedEl.querySelector(".v-toolbar");
        if (toolbar) {
            toolbar.style.display = "flex";
            const title = toolbar.querySelector(".v-toolbar__title");
            if (title) {
                title.style.setProperty("text-align", "center", "important");
                title.style.setProperty("width", "100%", "important");
                title.style.setProperty("font-weight", "bold", "important");
            }
            toolbar.style.boxShadow = "none";
        }
        
        const footer = clonedEl.querySelector(".v-data-footer");
        if (footer) footer.style.display = "none";

        const headers = clonedEl.querySelectorAll("th");
        headers.forEach(th => {
          th.style.setProperty("text-align", "center", "important");
          th.style.setProperty("vertical-align", "middle", "important");
          th.style.whiteSpace = "normal";
          th.style.fontSize = "12px";
        });

        const rows = clonedEl.querySelectorAll("tbody tr");
        rows.forEach(row => {
          const cells = row.querySelectorAll("td");
          cells.forEach((td, colIndex) => {
            td.style.padding = "4px 6px";
            td.style.verticalAlign = "middle";

            td.classList.remove("text-start", "text-left", "text-center", "text-right");

            if (colIndex === 0) {
              td.style.setProperty("text-align", "left", "important");
            } else {
              td.style.setProperty("text-align", "center", "important");
            }
          });
        });

        const canvas = await html2canvas(clonedEl, {
          scale: 3,
          useCORS: true,
          backgroundColor: '#ffffff',
          width: 950,
          windowWidth: 950
        });

        const imgData = canvas.toDataURL("image/png");
        document.body.removeChild(container);

        const slide = pres.addSlide();

        const slideWidth = 10;
        const slideHeight = 7.5;
        const marginX = 0.5;
        const startY = 0.5;

        const maxW = slideWidth - (marginX * 2);
        const maxH = slideHeight - (startY * 2);

        const imgRatio = canvas.width / canvas.height;
        let finalW = maxW;
        let finalH = finalW / imgRatio;

        if (finalH > maxH) {
          finalH = maxH;
          finalW = finalH * imgRatio;
        }

        const xPos = (slideWidth - finalW) / 2;

        slide.addImage({
          data: imgData,
          x: xPos,
          y: startY,
          w: finalW,
          h: finalH
        });
      }
      const planTypeFormated = formatedTextForZip(this.planType?.type_name);
      pres.writeFile({ 
        fileName: `Metricas_${planTypeFormated}_${moment().format(
          "YYYY_MM_DD_HH_mm"
        )}.pptx` 
      });
    },


  
      async openPanels() {
        const panelCount = this.$refs.expansionPanels.$el.querySelectorAll('.v-expansion-panel').length;
        if (this.panel.length !== panelCount) {
          return new Promise(resolve => {
            this.panel = Array.from({ length: panelCount }, (_, index) => index);
            setTimeout(() => {
              resolve(); 
            }, 1000);
          });
        }
      },
  
      async downloadTables(refName){
        const dateTableComponent = this.$refs[refName];
        if (!dateTableComponent) {
          //showSnackBar(`No existe la referencia ${refName}`, "error");
          return null;
        }
  
        const dateTable = dateTableComponent.$el;
        if (!dateTable) {
          showSnackBar(`No se encontró el dateTable dentro del componente.`, "error");
          return null;
        }
        const dataFooter = dateTable.querySelector('.v-data-footer');
        dataFooter.style.visibility = 'hidden';
      
        return new Promise((resolve, reject) => {
          html2canvas(dateTable, {
            backgroundColor: '#fff',
            useCORS: true,
            scale: 2
          }).then(canvas => {
            canvas.toBlob((blob) => {
              dataFooter.style.visibility = 'visible';
              resolve({ name: `${refName}.png`, blob });
            }, "image/png");
          })
          .catch(error => {
            showSnackBar('Hubo un error al generar la imagen', 'error');
            reject(error);
          });
        })
      },

    },

    components: {
        BarChart: Bar,
        EChartsBarSimple,
        EChartsBarDouble
    },
}